import { KkmNetworkBillingStatusModel } from './kkm-network-info.types';

export const KKM_NETWORK_TARIFF: KkmNetworkBillingStatusModel[] = [
  {
    billingStatus: 0,
    title: 'kkm.billing.status.TARIFF_CONNECTED',
    className: 'green-text',
    name: 'connected',
  },
  {
    billingStatus: 1,
    title: 'kkm.billing.status.TARIFF_ACTIVATED',
    className: 'green-text',
    name: 'activated',
  },
  {
    billingStatus: 2,
    title: 'kkm.billing.status.TARIFF_STOPPED',
    className: 'grey-text',
    name: 'stopped',
  },
  {
    billingStatus: 3,
    title: 'kkm.billing.status.TARIFF_DISABLED',
    className: 'error-text',
    name: 'disabled',
  },
  {
    billingStatus: 4,
    title: 'kkm.status.BILLING_KKM_BLOCKED_STATUS',
    className: 'error-text',
    name: 'blocked',
  },
];
